import { LOCALE_CODE } from '~/constants';
import i18n from '~/i18n';
import { isNonEmpty } from '~/utils/fnUtil/fnUtil';
import { Form } from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import { pipe, prop, reject } from 'ramda';
import validatorjs from 'validatorjs';

const checkEmpty = (value) => {
  return pipe(reject(prop('invalid')), isNonEmpty)(value);
};

class TenantInviteForm extends Form {
  constructor(data, options) {
    super(data, options);
  }

  options() {
    return {
      validateOnInit: true,
      validateOnChange: true,
      validateOnBlur: false,
    };
  }

  /*
    Below we are returning a `plugins` object using the `validatorjs` package
    to enable `DVR` functionalities (Declarative Validation Rules).
  */
  plugins() {
    return {
      dvr: dvr({
        package: validatorjs,
        extend: ({ validator }) => {
          validator.register('checkEmpty', checkEmpty);
          const messages = validator.getMessages('en');
          messages['required.invitee'] = i18n.t('tenantInvite.emptyInvitee', '초대할 멤버 정보를 입력해 주세요.');
          messages['checkEmpty.invitee'] = i18n.t('tenantInvite.emptyInvitee', '초대할 멤버 정보를 입력해 주세요.');
          messages['max.invitationReason'] = i18n.t('form.rule.max', ':max자 이하로 입력해 주세요.');
          validator.setMessages('en', messages);
        },
      }),
    };
  }

  /*
    Return the `fields` as a collection into the `setup()` method
    with a `rules` property for the validation.
  */
  setup() {
    return {
      fields: [
        {
          name: 'invitee',
          rules: 'required|checkEmpty',
          value: [],
        },
        {
          name: 'locale',
          value: LOCALE_CODE.KO_KR,
        },
        {
          name: 'role',
          value: 'member',
        },
        {
          name: 'expirationDate',
          value: new Date(),
        },
        {
          name: 'invitationReason',
          rules: 'max:500',
          value: '',
        },
      ],
    };
  }
}

export default TenantInviteForm;
